import React, {Component} from 'react';
import Measure from 'react-measure';
import Paper from 'material-ui/Paper';

class CenteredMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: null,
      height: null,
    }
  }

  handleMeasure = ({bounds}) => {
    if (this.state.height !== bounds.height || this.state.width !== bounds.width) {
      this.setState({
        width: bounds.width,
        height: bounds.height,
      });
    }
  };

  render() {
    return (
      <Measure bounds onResize={this.handleMeasure}>
        {({measureRef}) =>
          <div
            ref={measureRef}
            style={{
              position: 'absolute',
              width: '45%',
              minWidth: 200,
              top: '48%',
              left: '50%',
              marginTop: -(this.state.height/2),
              marginLeft: -(this.state.width/2),
            }}
          >
            <Paper
              style={{
                background: 'transparent',
                transition: 'none',
                textAlign: 'center',
                lineHeight: 1.5,
              }}
              zDepth={0}
            >
              {this.props.children}
            </Paper>
          </div>
        }
      </Measure>
    );
  }
}

export default CenteredMessage;



// WEBPACK FOOTER //
// ./src/components/CenteredMessage/CenteredMessage.js